import React from 'react';

function useTimeRangePicker() {
  const [show, setShow] = React.useState<boolean>(false);

  const [startSelected, setStartSelected] = React.useState<Date>(new Date(0, 0, 0, 0, 0));
  const [endSelected, setEndSelected] = React.useState<Date>(new Date(0, 0, 0, 23, 50));

  const timeConverter = (time : Date) => {
    const result = time.toString().split(' ')[4].substring(0, 5);
    const firstTwoNumber = parseInt(result.substring(0, 2), 10);
    if (firstTwoNumber >= 22) {
      return `${firstTwoNumber - 12}:${result.split(':')[1]} PM`;
    } if (firstTwoNumber >= 12) {
      return `0${firstTwoNumber - 12}:${result.split(':')[1]} PM`;
    }
    return `${result} AM`;
  };

  return {
    show,
    setShow,
    setStartSelected,
    startSelected,
    endSelected,
    setEndSelected,
    timeConverter,
  };
}

export default useTimeRangePicker;
